// Color, label, and accommodation constants shared across EI panels.
// Pure data — no React, no formatting logic.

export const SCORE_COLORS = {
  campaign: "#10B981",
  quickwin: "#22C55E",
  monitor: "#EAB308",
  low: "#9CA3AF",
};

export const SCORE_TIER_LABELS = {
  campaign: "Campaign",
  quickwin: "Quick Win",
  monitor: "Monitor",
  low: "Low Priority",
};

export const SOURCE_COLORS = {
  ticketmaster: "#009CDE",
  serpapi: "#4285F4",
};

export const SOURCE_LABELS = {
  ticketmaster: "Ticketmaster",
  serpapi: "Google Events",
};

export const ACCOMMODATION_COLORS = {
  rv: { bg: "bg-blue-100 dark:bg-blue-900/40", text: "text-blue-700 dark:text-blue-300", dot: "#3B82F6" },
  cabin: { bg: "bg-purple-100 dark:bg-purple-900/40", text: "text-purple-700 dark:text-purple-300", dot: "#8B5CF6" },
  glamping: { bg: "bg-pink-100 dark:bg-pink-900/40", text: "text-pink-700 dark:text-pink-300", dot: "#EC4899" },
  tent: { bg: "bg-emerald-100 dark:bg-emerald-900/40", text: "text-emerald-700 dark:text-emerald-300", dot: "#10B981" },
};

export const UNCLASSIFIED_LABEL = "Unclassified";
